import { render, staticRenderFns } from "./FeeConfigPopup.vue?vue&type=template&id=e6727158&scoped=true"
import script from "./FeeConfigPopup.vue?vue&type=script&lang=js"
export * from "./FeeConfigPopup.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigPopup.vue?vue&type=style&index=0&id=e6727158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6727158",
  null
  
)

export default component.exports